import { RootRoute, Route, Router, Outlet } from '@tanstack/react-router';
import HomePage from './HomePage';
import TeacherDashboardPage from './teacher/TeacherDashboardPage';
import CreateQuizPage from './teacher/CreateQuizPage';
import EditQuizPage from './teacher/EditQuizPage';
import SessionControlPage from './teacher/SessionControlPage';
import JoinSessionPage from './student/JoinSessionPage';
import QuizParticipationPage from './student/QuizParticipationPage';
import ResultsPage from './student/ResultsPage';
import DebugAuthPage from './DebugAuthPage';

// Define the root route
const rootRoute = new RootRoute({
  component: () => (
    <div className="min-h-screen bg-gray-50">
      <Outlet />
    </div>
  ),
});

// Define routes
const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

// Teacher routes
const teacherRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/teacher',
  component: TeacherDashboardPage,
});

const createQuizRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/teacher/quizzes/new',
  component: CreateQuizPage,
});

const editQuizRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/teacher/quizzes/$quizId',
  component: EditQuizPage,
});

const sessionControlRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/teacher/sessions/$sessionId',
  component: SessionControlPage,
});

// Student routes
const joinSessionRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/join',
  component: JoinSessionPage,
  validateSearch: (search: Record<string, unknown>) => ({
    code: search.code as string | undefined,
  }),
});

const quizParticipationRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/quiz/$sessionId',
  component: QuizParticipationPage,
  validateSearch: (search: Record<string, unknown>) => ({
    nickname: search.nickname as string,
    participantId: search.participantId as string,
  }),
});

const resultsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/quiz/$sessionId/results',
  component: ResultsPage,
  validateSearch: (search: Record<string, unknown>) => ({
    participantId: search.participantId as string | undefined,
  }),
});

const debugAuthRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/debug-auth',
  component: DebugAuthPage,
});

// Create the router
const routeTree = rootRoute.addChildren([
  indexRoute,
  teacherRoute,
  createQuizRoute,
  editQuizRoute,
  sessionControlRoute,
  joinSessionRoute,
  quizParticipationRoute,
  resultsRoute,
  debugAuthRoute,
]);

export const router = new Router({ routeTree });

// Register the router for maximum type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}